import React from "react";
import { UI_BODY_SM } from "oolib";
import { StyledPanel } from "../styled";
import { DescriptionText } from "./DescriptionText";

export const SidebarSection = ({ title, description, children }) => (
  <StyledPanel>
    <UI_BODY_SM semibold>{title}</UI_BODY_SM>
    {description ? <DescriptionText>{description}</DescriptionText> : null}
    {children}
  </StyledPanel>
);


